export default "__VITE_ASSET__DREXUA59__"